<script setup lang="ts">
import { useFileDialog } from "@vueuse/core"
import { watch } from "vue"
import useAnalytics from "@/utils/analytics"

interface Props {
  accept?: string
  multiple?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  accept: ".tsv,.csv,.txt,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  multiple: false,
})

const emit = defineEmits<{
  change: [files: File[]]
}>()

const { trackEvent } = useAnalytics()

const fileDialog = useFileDialog({
  accept: props.accept,
  multiple: props.multiple,
})

watch(fileDialog.files, (files) => {
  if (!files || files.length === 0) {
    return
  }

  const fileArray = Array.from(files)
  emit("change", fileArray)
  fileDialog.reset()
})

function buttonClick() {
  trackEvent("file_import_clicked")
  fileDialog.open()
}
</script>

<template>
  <div>
    <slot :button-click="buttonClick">
      <KButton
        variety="tertiary"
        color="violet"
        class="mt-2"
        @click="buttonClick()"
      >
        Browse
      </KButton>
    </slot>
  </div>
</template>
